// @flow
import type { BasketItem, TestSchedule, Product, CompanyBranch } from "../../lib/Types";
import type { DropDownItem } from "../DropDown";
import DropDown from "../DropDown";
import { fetchJson } from "../../lib/Fetching";
import React from "react";

type Props = {
  company_id: ?number,
  onBranchChange: (CompanyBranch) => void,
  value: number,
  includeBlank: ?boolean,
  blankLabel: ?string,
  permission_code: ?string,
  withProducts: ?boolean,
};

type State = {
  companyBranches: Array<CompanyBranch>,
};

export default class CompanyBranchDropDown extends React.Component<Props, State> {
  static defaultProps = {
    includeBlank: false,
    blankLabel: I18n.t("select_branch"),
    withProducts: false,
  };

  state = {
    companyBranches: [],
  };

  componentDidMount() {
    const {
      company_id,
      permission_code,
      onBranchChange,
      includeBlank,
      withProducts,
      value,
    } = this.props;
    if (!company_id) return;
    fetchJson("/company_branches.json", {
      company_id,
      permission_code,
      with_products: withProducts,
    }).then((companyBranches: Array<CompanyBranch>) => {
      this.setState({ companyBranches }, () => {
        const companyBranches = this.state.companyBranches;
        if (!includeBlank && companyBranches && companyBranches.length === 1 && !value) {
          onBranchChange(companyBranches[0]);
        }
      });
    });
  }

  branchChanged = (selected: DropDownItem) => {
    const { onBranchChange } = this.props;
    const { companyBranches } = this.state;
    onBranchChange(companyBranches.find((b) => b.id === selected.value));
  };

  branchOptions = (): Array<DropDownItem> => {
    const { includeBlank, blankLabel } = this.props;
    const { companyBranches } = this.state;
    var branchOptions: Array<DropDownItem> = [];
    if (includeBlank) {
      branchOptions.push({
        value: "",
        label: blankLabel,
      });
    }
    branchOptions = branchOptions.concat(
      companyBranches.map((b) => ({
        value: b.id,
        label: b.name,
      }))
    );
    return branchOptions;
  };

  render() {
    const { value, blankLabel } = this.props;
    return (
      <DropDown
        options={this.branchOptions()}
        value={value}
        placeholder={blankLabel}
        onChange={this.branchChanged}
      />
    );
  }
}
